<template>
  <div>
    <baidu-map class="map"
               center="北京"
               @ready="handler">
    </baidu-map>
  </div>
</template>
<script>
export default {
  name: 'commap',
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3
    }
  },
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 116.404
      this.center.lat = 39.915
      this.zoom = 15
    }
  }
}
</script>
<style>
/* The container of BaiduMap must be set width & height. */
.map {
  width: 15rem;
  height: 10rem;
}
</style>


// WEBPACK FOOTER //
// src/components/mind/map.vue